<template>
  <div class="icon-box">
    <img
      id="ballBtn"
      src="@/assets/image/icon-robot.png"
      class="icon-robot"
      alt=""
      srcset=""
      :style="{
        bottom: iocnElBottom + 'px',
        right: iocnElRight + 'px'
      }"
      v-if="isSuspension"
      @click="clickBall"
      @mousedown="ballMoveDown"
    />
    <img
      id="ballBtn"
      src="@/assets/image/icon-ai.png"
      class="icon-ai"
      v-else
      :style="iconStyle"
      @click="clickBall"
    />
  </div>
</template>
  <script>
export default {
  props: {
    // 按钮位置
    iocnBottom: {
      type: Number,
      default: 150
    },
    iocnRight: {
      type: Number,
      default: -26
    },
    isSuspension: {
      type: Boolean,
      default: true
    },
    iconStyle: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isDragging: false,
      ballDom: null,
      mousedownPos: {
        x: 0,
        y: 0
      },
      containerProfile: {},
      iocnElRight: -26,
      iocnElBottom: 150,
      bindDomProfile: {}
    }
  },
  // watch: {
  //   iocnRight() {
  //     this.iocnElRight = this.iocnRight
  //   },
  //   iocnBottom() {
  //     this.iocnElBottom = this.iocnBottom
  //   },
  // },
  mounted() {
    this.ballDom = document.getElementById('ballBtn')
    this.containerProfile = {
      bottom: window.innerHeight,
      left: 0,
      right: window.innerWidth,
      top: 0
    }
    this.iocnElRight = this.iocnRight
    this.iocnElBottom = this.iocnBottom
  },
  methods: {
    ballMoveDown(event) {
      event.preventDefault()
      this.isDragging = true
      this.bindDomProfile = this.ballDom.getBoundingClientRect()
      this.mousedownPos.x = event.clientX
      this.mousedownPos.y = event.clientY
      window.addEventListener('mousemove', this.ballMove, false)
      window.addEventListener('mouseup', this.ballUp, false)
    },
    ballMove(event) {
      if (!this.isDragging) return

      const moveArrangeY = this.containerProfile.bottom - this.bindDomProfile.height
      const clientY = event.clientY
      const moveYDiff = clientY - this.mousedownPos.y

      // 只计算垂直方向的移动
      let canMoveY = Math.max(0, Math.min(this.bindDomProfile.top + moveYDiff, moveArrangeY))
      this.iocnElBottom = window.innerHeight - canMoveY - this.bindDomProfile.height
    },
    ballUp() {
      this.isDragging = false
      window.removeEventListener('mousemove', this.ballMove)
      window.removeEventListener('mouseup', this.ballUp)
    },
    clickBall() {
      this.$emit('open')
    }
  }
}
</script>
  <style scoped>
.icon-box {
  display: inline-block;
  margin-right: 16px;
}
.icon-robot {
  position: fixed;
  width: 70px;
  height: 105px;
  z-index: 9999;
  transform: rotate(-15deg);
  transform-origin: center center;
  cursor: pointer;
}
.icon-ai {
  width: 20px;
  height: 20px;
  cursor: pointer;
  vertical-align: middle;
}
</style>
  